import { ClaimRecord } from '@typesApp/ClaimRecord'
import { ServiceStatus, ServiceType } from '@connector/types'
import { getInsuranceToggleState } from '@utils/insuranceToggleUtil'
import { isInsuranceMemberNoBenefitsAvailable } from '@utils/insuranceMemberUtil'

type ServiceStatusParams = {
  claimRecordId: string | undefined
  claimRecord: ClaimRecord | undefined
  claimRecordDeleted: boolean | undefined
}

export const getServiceStatus = (
  serviceType: ServiceType | 'default',
  params: ServiceStatusParams
): ServiceStatus | undefined => {
  const { claimRecordId, claimRecord, claimRecordDeleted } = params

  if (claimRecordId && claimRecord) {
    const { toggleOn } = getInsuranceToggleState({ claimRecord, claimRecordDeleted })
    let isReady = toggleOn

    if (serviceType === 'product-quote') {
      isReady = toggleOn && !isInsuranceMemberNoBenefitsAvailable(claimRecord.status)
    }

    return isReady ? 'ready' : 'unavailable'
  } else if (!claimRecordId) {
    return 'unavailable'
  }
}
